import styled from "styled-components";
import { theme } from "uikit";

const Label = styled.div`
	font-family: Inter;
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: 16px;

	color: ${theme.colors.primary};
`;

export default Label;
